"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressLabelText = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _Icon = require("../../../../../UIElements/Icons/PetSure/Icon");
require("./AddressLabelText.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AddressLabelText = _ref => {
  let {
    fieldFormContext,
    onEditAddress = () => {}
  } = _ref;
  const hookFormContext = (0, _reactHookForm.useFormContext)();
  const formContext = fieldFormContext || hookFormContext;
  const [suburb, state, postcode, address] = (0, _reactHookForm.useWatch)({
    control: formContext.control,
    name: ['owner.suburb', 'owner.state', 'owner.postcode', 'owner.address']
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "formField textField",
    title: "Display an address info"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "owner.streetAddress"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "labelText mandatory"
  }, " Street address ")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "AddressLabelKeyValuePair WithButton"
  }, "Address: ", address.split(',').shift(), /*#__PURE__*/_react.default.createElement("span", {
    className: "divisor"
  }, " | "), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "button text_only",
    onClick: onEditAddress
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "pencil"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "labelText"
  }, "Edit"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "AddressLabelKeyValuePair"
  }, "Suburb: ", suburb), /*#__PURE__*/_react.default.createElement("div", {
    className: "AddressLabelKeyValuePair"
  }, "State: ", state), /*#__PURE__*/_react.default.createElement("div", {
    className: "AddressLabelKeyValuePair"
  }, "Postcode: ", postcode)));
};
exports.AddressLabelText = AddressLabelText;
AddressLabelText.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldFormContext: _propTypes.default.any.isRequired,
  onEditAddress: _propTypes.default.func
};